import { EOrderDeliveryStatus, EOrderHistoryType, EOrderShippingMethod } from '../../types'
import { BadgeProps } from '@hubii/ds-hubii/lib/components/Badge/Badge'

export const orderDeliveryStatusColors: Record<EOrderDeliveryStatus, BadgeProps['status']> = {
  [EOrderDeliveryStatus.WaitingBiding]: 'neutral',
  [EOrderDeliveryStatus.WaitingOrder]: 'primary',
  [EOrderDeliveryStatus.WaitingHub]: 'primary',
  [EOrderDeliveryStatus.WaitingGroup]: 'primary',
  [EOrderDeliveryStatus.Refused]: 'error',
  [EOrderDeliveryStatus.Ignored]: 'neutral',
  [EOrderDeliveryStatus.SearchingCourier]: 'primary',
  [EOrderDeliveryStatus.CourierNotFound]: 'error',
  [EOrderDeliveryStatus.CourierFound]: 'primary',
  [EOrderDeliveryStatus.PickingUp]: 'primary',
  [EOrderDeliveryStatus.Delivering]: 'primary',
  [EOrderDeliveryStatus.Delivered]: 'success',
  [EOrderDeliveryStatus.Canceled]: 'error',
  [EOrderDeliveryStatus.Processing]: 'neutral',
  [EOrderDeliveryStatus.Lost]: 'error',
  [EOrderDeliveryStatus.FailedToDelivery]: 'error',
}

export const shippingMethodStatusColors: Record<EOrderShippingMethod, BadgeProps['status']> = {
  [EOrderShippingMethod.Pickup]: 'success',
  [EOrderShippingMethod.QuickCommerce]: 'success',
  [EOrderShippingMethod.Express]: 'success',
  [EOrderShippingMethod.Scheduled]: 'primary',
  [EOrderShippingMethod.Dropoff]: 'warning',
  [EOrderShippingMethod.Flex]: 'primary',
}

export const orderHistoryTypeColors: Record<EOrderHistoryType, BadgeProps['status']> = {
  [EOrderHistoryType.Accepted]: 'success',
  [EOrderHistoryType.Refused]: 'error',
  [EOrderHistoryType.Viewed]: 'neutral',
  [EOrderHistoryType.RefusedAfterAccepted]: 'error',
  [EOrderHistoryType.AcceptedAfterRefused]: 'success',
  [EOrderHistoryType.Ignored]: 'neutral',
}
